import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';
import type { DocumentImage } from 'types/entities/documentImage';
import type { SignaturePlaceholder } from 'types/entities/signaturePlaceholder';

export interface AdviceRoomDocumentMetadataPatchOptions {
  sectionMarks: DocumentImage[];
  signaturePlaceholders: SignaturePlaceholder[];
  textPlaceholders: SignaturePlaceholder[];
}

export function adviceRoomDocumentMetadataApi(path: string) {
  return {
    path,
    PATCH: (params: AdviceRoomDocumentMetadataPatchOptions) =>
      api.patch<JsonApiResponseSingle>(path, {
        data: {
          attributes: {
            metadata: mapFormData(params),
          },
        },
      }),
  };
}
